import { STATUS_CATEGORY_TYPE } from '@atlassian/jira-platform-field-config';
import { STATUS_CATEGORY_FIELD_GQL_TYPE } from '../constants';
import type { JiraStatusCategoryField } from '../fragment/types';
import type { TransformedStatusCategoryField } from '../types';
import type { StatusCategoryTransformersMapping } from './types';

export const transformStatusCategoryField = (): StatusCategoryTransformersMapping => ({
	[STATUS_CATEGORY_FIELD_GQL_TYPE]: (
		field: JiraStatusCategoryField,
	): TransformedStatusCategoryField | null => {
		if (field.__typename !== STATUS_CATEGORY_FIELD_GQL_TYPE) {
			return null;
		}

		return {
			type: STATUS_CATEGORY_TYPE,
			fieldId: field.fieldId,
			value: field.statusCategory
				? {
						statusCategoryId: field.statusCategory.statusCategoryId,
						name: field.statusCategory.name ?? '',
					}
				: null,
		};
	},
});
